export default __webpack_public_path__ + "static/media/pancreas3.3b64af41.jpg";